import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c25f6ad8 = () => interopDefault(import('../pages/vacancies/index.vue' /* webpackChunkName: "pages/vacancies/index" */))
const _a76d7ce4 = () => interopDefault(import('../pages/cargo-landing/_.vue' /* webpackChunkName: "" */))
const _8c4f0d1e = () => interopDefault(import('../pages/transport/_.vue' /* webpackChunkName: "pages/transport/_" */))
const _a46eb938 = () => interopDefault(import('../pages/transport/index.vue' /* webpackChunkName: "pages/transport/index" */))
const _66f41908 = () => interopDefault(import('../pages/tip-gruza/_/products.vue' /* webpackChunkName: "pages/tip-gruza/_/products" */))
const _afe45e2c = () => interopDefault(import('../pages/tip-gruza/_/index.vue' /* webpackChunkName: "pages/tip-gruza/_/index" */))
const _e4a9facc = () => interopDefault(import('../pages/tip-gruza/index.vue' /* webpackChunkName: "pages/tip-gruza/index" */))
const _2a63204e = () => interopDefault(import('../pages/sets/_.vue' /* webpackChunkName: "pages/sets/_" */))
const _1dca5b3a = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _bfde85c0 = () => interopDefault(import('../pages/routes/_cityfrom/_cityto/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/_cityto/index" */))
const _f33f572c = () => interopDefault(import('../pages/routes/_cityfrom/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/index" */))
const _eca83cf6 = () => interopDefault(import('../pages/routes/index.vue' /* webpackChunkName: "pages/routes/index" */))
const _fab31f3c = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _6535dddf = () => interopDefault(import('../pages/otrasli/_/products.vue' /* webpackChunkName: "pages/otrasli/_/products" */))
const _7ea48d32 = () => interopDefault(import('../pages/otrasli/_/index.vue' /* webpackChunkName: "pages/otrasli/_/index" */))
const _6134e657 = () => interopDefault(import('../pages/otrasli/index.vue' /* webpackChunkName: "pages/otrasli/index" */))
const _ced2f6f4 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _cb65b464 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _0cbaa97a = () => interopDefault(import('../pages/lk/index.vue' /* webpackChunkName: "pages/lk/index" */))
const _f548f6d0 = () => interopDefault(import('../pages/gruzopodemnost/_.vue' /* webpackChunkName: "pages/gruzopodemnost/_" */))
const _c61879ea = () => interopDefault(import('../pages/gruzopodemnost/index.vue' /* webpackChunkName: "pages/gruzopodemnost/index" */))
const _4706d34c = () => interopDefault(import('../pages/events/_slug.vue' /* webpackChunkName: "pages/events/_slug" */))
const _48bd7494 = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _69dac934 = () => interopDefault(import('../pages/distillation/_id/_vin.vue' /* webpackChunkName: "pages/distillation/_id/_vin" */))
const _0efb1138 = () => interopDefault(import('../pages/distillation/_id/index.vue' /* webpackChunkName: "pages/distillation/_id/index" */))
const _0f0b24cd = () => interopDefault(import('../pages/distillation/index.vue' /* webpackChunkName: "pages/distillation/index" */))
const _fa1ff80e = () => interopDefault(import('../pages/cargo-rate-calculator/index.vue' /* webpackChunkName: "pages/cargo-rate-calculator/index" */))
const _781f8120 = () => interopDefault(import('../pages/articles/_slug.vue' /* webpackChunkName: "pages/articles/_slug" */))
const _74b23e90 = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _26991052 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/vacancies",
    component: _c25f6ad8,
    name: "vacancies"
  }, {
    path: "/ural/:slug",
    components: {
      default: _a76d7ce4
    }
  }, {
    path: "/transport/*",
    component: _8c4f0d1e,
    name: "transport-all"
  }, {
    path: "/transport",
    component: _a46eb938,
    name: "transport"
  }, {
    path: "/tip-gruza/*/products",
    component: _66f41908,
    name: "tip-gruza-all-products"
  }, {
    path: "/tip-gruza/*",
    component: _afe45e2c,
    name: "tip-gruza-all"
  }, {
    path: "/tip-gruza",
    component: _e4a9facc,
    name: "tip-gruza"
  }, {
    path: "/sets/*",
    component: _2a63204e,
    name: "sets-all"
  }, {
    path: "/search",
    component: _1dca5b3a,
    name: "search"
  }, {
    path: "/routes/:cityfrom/:cityto",
    component: _bfde85c0,
    name: "routes-cityfrom-cityto"
  }, {
    path: "/routes/:cityfrom",
    component: _f33f572c,
    name: "routes-cityfrom"
  }, {
    path: "/routes",
    component: _eca83cf6,
    name: "routes"
  }, {
    path: "/product/:slug?",
    component: _fab31f3c,
    name: "product-slug"
  }, {
    path: "/otrasli/*/products",
    component: _6535dddf,
    name: "otrasli-all-products"
  }, {
    path: "/otrasli/*",
    component: _7ea48d32,
    name: "otrasli-all"
  }, {
    path: "/otrasli",
    component: _6134e657,
    name: "otrasli"
  }, {
    path: "/news/:slug",
    component: _ced2f6f4,
    name: "news-slug"
  }, {
    path: "/news",
    component: _cb65b464,
    name: "news"
  }, {
    path: "/lk",
    component: _0cbaa97a,
    name: "lk"
  }, {
    path: "/gruzopodemnost/*",
    component: _f548f6d0,
    name: "gruzopodemnost-all"
  }, {
    path: "/gruzopodemnost",
    component: _c61879ea,
    name: "gruzopodemnost"
  }, {
    path: "/events/:slug",
    component: _4706d34c,
    name: "events-slug"
  }, {
    path: "/events",
    component: _48bd7494,
    name: "events"
  }, {
    path: "/distillation/:id/:vin",
    component: _69dac934,
    name: "distillation-id-vin"
  }, {
    path: "/distillation/:id",
    component: _0efb1138,
    name: "distillation-id"
  }, {
    path: "/distillation",
    component: _0f0b24cd,
    name: "distillation"
  }, {
    path: "/cargo-rate-calculator",
    component: _fa1ff80e,
    name: "cargo-rate-calculator"
  }, {
    path: "/cargo-landing/*",
    component: _a76d7ce4,
    name: "cargo-landing-all"
  }, {
    path: "/articles/:slug",
    component: _781f8120,
    name: "articles-slug"
  }, {
    path: "/articles",
    component: _74b23e90,
    name: "articles"
  }, {
    path: "/*",
    component: _26991052,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
